// Per-email upload memory so the user can't accidentally re-upload the same
// attachment twice. Keyed by Outlook itemId + attachment id.
//
// Note: Office.js attachment ids are stable for the lifetime of the message
// (they're EWS attachment ids), so this works across pane open/close and
// across browser sessions.
const STORAGE_KEY = 'tl.outlook.uploads.v1';
function load() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    }
    catch {
        return {};
    }
}
function save(s) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
}
export function getCurrentItemId() {
    return Office.context.mailbox?.item?.itemId ?? '';
}
export function getUploadsForCurrentItem() {
    const itemId = getCurrentItemId();
    if (!itemId)
        return {};
    return load()[itemId] ?? {};
}
export function recordUpload(attachmentId, rec) {
    const itemId = getCurrentItemId();
    if (!itemId)
        return;
    const store = load();
    store[itemId] = { ...(store[itemId] ?? {}), [attachmentId]: rec };
    save(store);
}
export function clearUploadsForCurrentItem() {
    const itemId = getCurrentItemId();
    if (!itemId)
        return;
    const store = load();
    delete store[itemId];
    save(store);
}
